import React from "react";
import {isBrowser, isMobile} from 'react-device-detect';
import LabOrderPendingActions from "../ActionsComponents/LabOrderPendingActions";
import LabOrderWaitingForCallActions from "../ActionsComponents/LabOrderWaitingForCallActions";
import LabOrderWaitingForPaymentActions from "../ActionsComponents/LabOrderWaitingForPaymentActions";
import LabOrderWaitingForPriceActions from "../ActionsComponents/LabOrderWaitingForPriceActions";
import LabOrderWaitingForResultActions from "../ActionsComponents/LabOrderWaitingForResultActions";
import LabOrderWaitingForSamplingActions from "../ActionsComponents/LabOrderWaitingForSamplingActions";

const LabOrderActions = (props) => {
  const { order } = props;
  const renderActions = () => {
      switch (order.vendor_status) {
        case "waiting_for_price":
          return <LabOrderWaitingForPriceActions order={order} />
        case "waiting_for_payment":
          return <LabOrderWaitingForPaymentActions order={order} />
        case "waiting_for_call":
          return <LabOrderWaitingForCallActions order={order} />
        case "waiting_for_sampling":
          return <LabOrderWaitingForSamplingActions {...order} />
        case "pending":
          return <LabOrderPendingActions order={order} />
        case "waiting_for_result":
          return <LabOrderWaitingForResultActions order={order} />
        default:
          break;
      }
}
  return (
    <>
      {renderActions()}
    </>
  );
};

export default LabOrderActions;
